export const iconFontAwesomeGamingSteam = (
	<i className="fa-solid fa-steam"></i>
);
